class featureSizeConversion extends HTMLElement {
	
	constructor() {
        super();
     
        for (let elm of document.querySelectorAll(".product-size-switch")) {
            elm.addEventListener('click', this.onUnitSwitch);
        }
	}
	
	onUnitSwitch(event) {  
		let sizeValues = event.target.closest('.product__features-size--container').querySelectorAll('.size-frame-value');
	        sizeValues.forEach((sizeValue)=> {
	        	var currentValue = 	sizeValue.dataset.value;
	        	if(currentValue != null && currentValue != '') {
	                if(event.target.dataset.unit == 'mm') {
	    	        	currentValue = currentValue / 25.4;
	    	        	sizeValue.dataset.value = currentValue.toFixed(2);
	    	        	sizeValue.dataset.unit = 'in';
	    	        	sizeValue.innerHTML = currentValue.toFixed(2) + 'IN';
	    	        } else {
	    	        	currentValue = currentValue * 25.4;
	    	        	sizeValue.dataset.value = currentValue.toFixed(0);
	    	        	sizeValue.dataset.unit = 'mm';
	    	        	sizeValue.innerHTML = currentValue.toFixed(0) + 'MM';
	    	        }
	        	}
            }
	    );
	        
	    if(event.target.dataset.unit == 'mm') {
	    	event.target.dataset.unit = 'in';	
	    	event.target.innerHTML = event.target.dataset.labelmm;	
	    } else {
	    	event.target.dataset.unit = 'mm';	
	    	event.target.innerHTML = event.target.dataset.labelin;
	    }
	}
}

customElements.define('feature-size-conversion', featureSizeConversion);